export default __webpack_public_path__ + "css/deliveryNew.bundle.css";